<template>
  <c-search-form :input-search-items="searchItems"
                 :form-name="formName"
                 :hiddenFields="hiddenFields"
                 model="searchForm" :fields="fields"
                 key-property="logId"
                 :search-url="searchUrl"
                 :accept-create="false"
                 :accept-delete="false"
                 @showImage="showImage"
                 :acceptExport="1"
                 @dowloadImage="dowloadImage"
  >
  </c-search-form>
</template>

<script>
import axios from "axios";
import CSearchForm from "../../../components/form/ManageForm";
import {message} from "@/shared/message";
import {promises as fs} from "fs";

export default {
  name: 'log-management',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "Log Math",
      searchUrl: null,
      searchItems: [
        {
          type: "text",
          name: "phoneNumber",
          label: "Nhập List Số điện thoại dạng 0974152145;0974152147",
          placeHolder: "",
          focus: true
        },
      ],
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'accountId',
          text: 'Account Id',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumberAcc',
          text: 'Số điện thoại đăng ký',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumberOrder',
          text: 'Số điện thoại mua hàng',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        /*        {
                  value: 'isCheckAccount',
                  text: 'Mô tả',
                  width: "5%",
                  sortable: false,
                  headerStyle: "text-align:left"
                },*/
        {
          value: 'createDate',
          text: 'Ngày học',
          sortable: false,
          search: false,
          dateFormat: 'dd/MM/yyyy',
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'createDate',
          text: 'Giờ học',
          sortable: false,
          search: false,
          dateFormat: 'hh:mm:ss',
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'lessonName',
          text: 'Bài Học',
          sortable: false,
          search: false,
          width: "15%",
          headerStyle: "text-align:center",
        },
        {
          value: 'point',
          text: 'Kết quả học',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        }
      ]
    }
  },
  methods: {

  },
  created() {
    this.searchUrl = "/kidAccountClass/searchLastLogMath?sortField=status,classId&";
  }

}
</script>
